import React from "react";

import "../styles/footer.css";

export const FooterDashboard = () => {
  return (
    <footer className="footer">
      <p className="paragraph-md">Need help? Contact our Customer Support</p>
      <div className="footer__contact">
        <p className="paragraph-md">&copy; Quickmove 2024 </p>
        <a
          href="https://www.quickmove.co.nz/terms-and-conditions"
          target="_blank"
          rel="noopener noreferrer"
          className="paragraph-md semibold text-neutral-950"
        >
          Terms & Conditions
        </a>
      </div>
    </footer>
  );
};
